<template>
  <div>
    <dialog-view
        :open="id!==null"
        :title="'Платеж #'+id"
        :loading="loadState.isLoading"
        content-full-size big @cancel="$emit('cancel')">
      <template v-slot:barActions>
        <log entity-name="Pay" :entity-id="id"/>
      </template>
      <template v-slot:header v-if="loadState.isSuccess">
        <pay-info-header :pay="pay" @updated="load()" :visitServices="pay.visitServices"/>
      </template>
      <template v-slot:content v-if="loadState.isSuccess">
        <v-row no-gutters v-if="pay.visitServices.length>0">
          <v-col cols="12">
            <div v-for="(visit, index) in getVisits(pay.visitServices)" :key="visit.id">
              <v-row class="pa-0 ma-2">
                <v-col cols="6">
                  <span class="body-2 font-weight-medium">Визит #{{visit.id}}</span>
                  <v-btn color="primary" text class="ml-4" small @click="visitId=visit.id">
                    Подробнее
                  </v-btn>
                </v-col>
                <v-col cols="6" class="text-right py-0"></v-col>
                <v-col cols="auto">
                  <label-view title="Статус">
                    <template v-slot:content>
                      <visit-status v-if="statuses.length>0" :status="$tools.findById(statuses, visit.status)" :isPaidFull="visit.paySummary.isPaidFull" small/>
                    </template>
                  </label-view>
                </v-col>
                <v-col>
                  <label-view title="Специалист">
                    <template v-slot:content>
                      <UserFullName :user="visit.userSpec.user" type="spec"/> 
                      <div>
                        {{visit.userSpec.spec.name}}
                      </div>                     
                    </template>
                  </label-view>
                </v-col>
                <v-col cols="3">
                  <label-view title="Кабинет / Место">
                    <template v-slot:content>
                      <div>
                        {{visit.comPlace.comRoom.sid}} {{visit.comPlace.comRoom.name}}
                      </div>
                      <div>
                        {{visit.comPlace.name}}
                      </div>
                    </template>
                  </label-view>
                </v-col>
                <v-col cols="3">
                  <div>
                    <label-view title="Дата / Время">
                      <template v-slot:content>
                        <div>
                          {{$tools.dateFull(visit.begin)}}
                        </div>
                        <div>
                          {{$tools.time(visit.begin)}} - {{$tools.time(visit.end)}}
                        </div>
                      </template>
                    </label-view>
                  </div>
                </v-col>
                <v-col cols="12" class="py-0">
                  <label-view title="Услуги">
                    <template v-slot:content>
                      <v-simple-table dense>
                        <template v-slot:default>
                          <thead>
                          <tr>
                            <th>ID</th>
                            <th>Название</th>
                            <th class="text-center">Кол-во шт</th>
                            <th class="text-right">Цена</th>
                            <th class="text-center">Скидка</th>
                            <th class="body-2 font-weight-medium text-right">Итого</th>
                          </tr>
                          </thead>
                          <tbody>

                          <tr v-for="visitService in visit.visitServices" :key="visitService.id">
                            <td>{{ visitService.id }}</td>
                            <td>
                              <div>{{ visitService.name }}</div>
                              <v-chip class="mt-1 mr-2" small outlined>{{visitService.duration}} мин.</v-chip>
                              <v-chip v-if="visitService.mode==='oms'" class="mt-1 mr-2" small outlined>
                                ОМС<v-divider class="mx-2" vertical/>{{visitService.insur.name}}
                              </v-chip>
                              <v-chip v-if="visitService.mode==='dms'" class="mt-1 mr-2" small outlined>
                                ДМС<v-divider class="mx-2" vertical/>{{visitService.insur.name}}
                              </v-chip>
                              <v-chip v-if="visitService.mode==='contract'" class="mt-1 mr-2" small outlined>
                                Контракт<v-divider class="mx-2" vertical/>{{visitService.insur.name}}
                              </v-chip>
                              <v-chip v-if="visitService.medPlan!==null" class="mt-1 mr-2" small outlined>
                                План лечения<v-divider class="mx-2" vertical/>{{visitService.medPlan.name}}
                              </v-chip>
                              <div v-if="visitService.comment!==null" class="mt-1">
                                <v-icon small>mdi-comment-text-outline</v-icon>
                                <div class="caption mt-n5 ml-5">{{visitService.comment}}</div>
                              </div>
                            </td>
                            <td class="text-center">
                              {{visitService.count}}
                            </td>
                            <td class="text-right text-no-wrap">
                              {{ $tools.price(visitService.price) }}
                            </td>
                            <td class="text-right text-no-wrap">
                              {{$tools.price(visitService.discount)}}
                            </td>
                            <td class="text-right text-no-wrap">
                              {{ $tools.price(visitService.priceTotal) }}
                            </td>
                          </tr>
                          </tbody>
                        </template>
                      </v-simple-table>
                    </template>
                  </label-view>
                </v-col>
              </v-row>
              <v-divider v-if="index<getVisits(pay.visitServices).length-1"/>
            </div>
          </v-col>
        </v-row>
      </template>
    </dialog-view>
    <visit :visitId.sync="visitId" @reLoadTable="load()"/>
  </div>
</template>

<script>
import DialogView from "@/components/DialogView";
import LabelView from "@/components/LabelView";
import VisitStatus from "@/components/VisitStatus";
import Visit from "@/views/Visit/Visit";
import Log from "@/views/Log/Log";
import PayInfoHeader from "@/views/Pay/components/PayInfoHeader.vue";
import UserFullName from "@/componentsV2/custom/UserFullName.vue";
import Api from "@/Api";
import State from "@/plugins/state";

import {
  Entity_User,
  Entity_UserSpec,
  Entity_Spec,
  Entity_Pay,
  Entity_VisitService,
  Entity_Visit,
  Entity_Insur,
  Entity_ComPlace,
  Entity_ComRoom,
  Entity_MedPlan
} from "../../../EntityStoreCacheService";

export default {
  name:'Pay',
  components: {
    PayInfoHeader,
    Log, Visit, VisitStatus, LabelView, DialogView, UserFullName
  },
  props:['id'],
  data: () => ({
    loadState:new State(),
    pay:null,
    visitId:null,
    statuses:Api.model.Visit.statuses,
  }),
  watch: {
    id(){
      if(this.id!==null) this.load();
    }
  },
  methods:{
    load(){
      let rb = new Entity_Pay()
      .selects(Entity_Pay.id)
      .selects(Entity_Pay.type)
      .selects(Entity_Pay.amount)
      .selects(Entity_Pay.amountPayed)
      .selects(Entity_Pay.amountCash)
      .selects(Entity_Pay.amountCard)
      .selects(Entity_Pay.amountBankAccount)
      .selects(Entity_Pay.amountAccount)
      .selects(Entity_Pay.amountOms)
      .selects(Entity_Pay.amountDms)
      .selects(Entity_Pay.amountContract)
      .selects(Entity_Pay.amountInsur)
      .selects(Entity_Pay.kktName)
      .selects(Entity_Pay.kktQrCode)
      .selects(Entity_Pay.kktSlip)
      .selects(Entity_Pay.terminalName)
      .selects(Entity_Pay.slipCard)
      .selects(Entity_Pay.tranId)
      .selects(Entity_Pay.comment)
      .selects(Entity_Pay.created)
      .selects(Entity_Pay.cancelDateTime)
      .selects(Entity_Pay.isAcceptBankAccount)
      .selects(Entity_Pay.isAcceptOms)
      .selects(Entity_Pay.isAcceptDms)
      .selects(Entity_Pay.isAcceptContract)

      .selects([Entity_Pay.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.operatorUser, Entity_User.id].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.operatorUser, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.insur, Entity_Insur.id].join('.')) 
      .selects([Entity_Pay.insur, Entity_Insur.name].join('.')) 

      // payParent
      .selects([Entity_Pay.payParent, Entity_Pay.id].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.type].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amount].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountPayed].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountCash].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountCard].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountBankAccount].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountAccount].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountOms].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountDms].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountContract].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.amountInsur].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.kktName].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.terminalName].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.tranId].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.comment].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.created].join('.'))

      .selects([Entity_Pay.payParent, Entity_Pay.insur, Entity_Insur.id].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.insur, Entity_Insur.name].join('.'))

      .selects([Entity_Pay.payParent, Entity_Pay.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.payParent, Entity_Pay.operatorUser, Entity_User.id].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.operatorUser, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.operatorUser, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.payParent, Entity_Pay.operatorUser, Entity_User.secondName].join('.'))
     
      // payChild
      .selects([Entity_Pay.payChild, Entity_Pay.id].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.type].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amount].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountPayed].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountCash].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountCard].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountBankAccount].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountAccount].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountOms].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountDms].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountContract].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.amountInsur].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.kktName].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.terminalName].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.tranId].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.comment].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.created].join('.'))

      .selects([Entity_Pay.payChild, Entity_Pay.insur, Entity_Insur.id].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.insur, Entity_Insur.name].join('.'))

      .selects([Entity_Pay.payChild, Entity_Pay.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.payChild, Entity_Pay.operatorUser, Entity_User.id].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.operatorUser, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.operatorUser, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.payChild, Entity_Pay.operatorUser, Entity_User.secondName].join('.'))

      // visitServices
      .selects([Entity_Pay.visitServices, Entity_VisitService.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.name].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.comment].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.count].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.discount].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.duration].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.price].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.virtual_priceTotal].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.mode].join('.'))

      // medPlan
      .selects([Entity_Pay.visitServices, Entity_VisitService.medPlan, Entity_MedPlan.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.medPlan, Entity_MedPlan.name].join('.'))

      // insur
      .selects([Entity_Pay.visitServices, Entity_VisitService.insur, Entity_Insur.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.insur, Entity_Insur.name].join('.'))

      // visit
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.status].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.begin].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.end].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.virtual_paySummary].join('.'))

      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.firstName].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.lastName].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.user, Entity_User.secondName].join('.'))

      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.userSpec, Entity_UserSpec.spec, Entity_Spec.name].join('.'))

      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.comPlace, Entity_ComPlace.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.comPlace, Entity_ComPlace.name].join('.'))

      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.id].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.sid].join('.'))
      .selects([Entity_Pay.visitServices, Entity_VisitService.visit, Entity_Visit.comPlace, Entity_ComPlace.comRoom, Entity_ComRoom.name].join('.'))


      rb.filterAnd([Entity_Pay.entity, Entity_Pay.id].join('.') + ' =?', parseInt(this.id))

      rb.addStateCallback((v) => {
        this.loadState.setRequestBuilderState(v)
      })
      .page(null)
      .request((v)=>{       
        console.log('salkdaslkdjaskdjklasj',v)
        this.pay = v.items[0];
      }, (e)=>{
        this.$emit('loaded', [], 0);
        console.error(e.response.data.message);
      })  
    },
    getVisits(visitServices){
      let arr = [];
      visitServices.forEach((v)=>{
        if (arr.filter(v1 => v1.id === v.visit.id).length === 0) {
          v.visit.visitServices = [];
          arr.push(v.visit);
        }
      });
      arr.forEach((a)=>{
        visitServices.forEach((v)=>{
          if (a.id===v.visit.id) {
            a.visitServices.push(v);
          }
        });
      });
      return arr;
    },
  }
}
</script>